import { Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding-top: ${({ theme }) => theme.spacing(2)};
  & > :not(style) {
    margin-bottom: ${({ theme }) => theme.spacing(8)};
  }
`;

const BankContainer = styled.div`
  display: flex;
  align-items: center;
`;

export interface NotSupportedProps {
  bankName: string;
  iconUrl?: string;
  className?: string;
}

export const NotSupported = ({
  iconUrl,
  bankName,
  className,
}: NotSupportedProps) => {
  const { t } = useTranslation();
  return (
    <Container data-testid="not-supported" className={className}>
      <BankContainer>
        {iconUrl && (
          <img width="45" height="45" src={iconUrl} alt={`${bankName} logo`} />
        )}
        <Typography variant="h6">{bankName}</Typography>
      </BankContainer>

      <Typography>{t("domains.bankSelect.notSupported")}</Typography>
    </Container>
  );
};
